export function getScheduledRideInfo(ride) {
  if (!ride) return null;
  if (ride.scheduled_ride_info) return ride.scheduled_ride_info;
  if (ride.scheduled_time) return ride;
  return null;
}

export function formatScheduledRideDateTime(scheduledTime) {
  if (!scheduledTime) return { date: null, time: null };

  const [datePart, timePart = ""] = scheduledTime.trim().split(" ");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hours, minutes] = (timePart || "").split(":");

  const date = new Date(year, month - 1, day);
  const formattedDate = date.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  return {
    date: formattedDate,
    time: `${hours}:${minutes}`,
  };
}
